import * as React from "react";
import classnames from "classnames";
import { List } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
/* empty css                     */
const StoreFacilities = ({ className, labels, facilities, ...rest }) => {
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("store-facilities-stores-v2", className) }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2" }, labels.title), /* @__PURE__ */ React.createElement(List, { items: facilities, icon: "checkmark" }));
};
export {
  StoreFacilities as default
};
//# sourceMappingURL=StoreFacilities.js.map
